import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import FacebookIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import { SOCIAL_LINKS } from '../v2/config/footerLinks';
import { footerColumnTitleSx } from './footerSectionStyles';

const SOCIAL_ICONS = [FacebookIcon, InstagramIcon, WhatsAppIcon, LinkedInIcon];

const iconSx = {
  fontSize: { xs: 22, sm: 24 },
  cursor: 'pointer',
  background: '#a4243d',
  color: '#FFF0D9',
  borderRadius: '50%',
  border: '2px solid #a4243d',
  p: 0.5,
  flexShrink: 0,
  boxSizing: 'content-box',
  transition: 'opacity 0.15s ease',
  '&:hover': { opacity: 0.88 },
};

export default function FooterSocialLinks({ sx }) {
  const openUrl = useCallback((url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <Box sx={{ ...sx }}>
      <Box sx={footerColumnTitleSx}>Connect with Us</Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: { xs: 1, sm: 1.25 },
          flexWrap: 'nowrap',
          background: '#FFF0D9',
          borderRadius: '8px',
          padding: { xs: '8px 10px', sm: '10px 12px' },
          width: 'fit-content',
          maxWidth: '100%',
        }}
      >
        {SOCIAL_LINKS.map((link, index) => {
          const Icon = SOCIAL_ICONS[index];
          return (
            <Icon
              key={link.label}
              sx={iconSx}
              onClick={() => openUrl(link.url)}
              aria-label={link.label}
            />
          );
        })}
      </Box>
    </Box>
  );
}
